const mapToStr = function (mapList) {
  return mapList.filter((item) => item.title !== '全部').map((item) => item.title)
}
const arrToMap = function (mapList) {
  return mapList
    .filter((item) => item.title !== '全部')
    .reduce((pre, item) => {
      return Object.assign(pre, { [item.value]: item.title })
    }, {})
}

/**
 * 包裹类型
 *
 * */
export const packageType = [
  {
    value: '',
    title: '全部'
  },
  {
    value: 1,
    title: 'D2C'
  },
  {
    value: 2,
    title: 'B2B'
  }
]
export const packageTypeStr = arrToMap(packageType)

/**
 * 上报采购异常类型
 *
 * */
export const abnormalPurchase = [
  {
    value: '104',
    title: '扫不出'
  },
  {
    value: '101',
    title: '到错货'
  },
  {
    value: '103',
    title: '多件'
  },
  {
    value: '102',
    title: '少件'
  }
]
/**
 * 上报采购异常类型————简单检品
 *
 * */
export const abnormalPurchase_inHouse = [
  {
    value: '101',
    title: '到错货（尺码、款发错）'
  },
  {
    value: '103',
    title: '多件'
  },
  {
    value: '102',
    title: '少件'
  },
  {
    value: '105',
    title: '少件到货'
  }
]
/**
 * 上报采购异常类型
 *
 * */
export const abnormalPurchase_check = [
  {
    value: '101',
    title: '到错货'
  },
  {
    value: '103',
    title: '多件'
  },
  {
    value: '102',
    title: '少件'
  }
]
export const abnormalPurchaseMap = arrToMap(abnormalPurchase)

/**
 * 拆包新增异常类型
 *
 * */
export const abnormalPkgSplit = [
  {
    value: 1,
    title: '多件'
  },
  {
    value: 0,
    title: '少件'
  }
  // {
  //   value: 'otherIssues', // warehousing
  //   title: '其他入库问题'
  // },
]
export const abnormalPkgSplitMap = arrToMap(abnormalPkgSplit)

/**
 * 上报采购客户类型
 *
 * */
export const abnormalClient = [
  {
    value: '201',
    title: '颜色差异'
  },
  {
    value: '204',
    title: 'logo差异'
  },
  {
    value: '207',
    title: '材质/面料差异'
  },
  {
    value: '202',
    title: '商品上有中文'
  },
  {
    value: '205',
    title: '尺码差异'
  },
  {
    value: '203',
    title: '配件差异（口袋，腰带，纽扣，拉链，拉绳）'
  },
  {
    value: '206', // warehousing
    title: '设计差异（压线，领口，袖口，花纹，衣服设计等）'
  }
]
export const abnormalClientMap = arrToMap(abnormalClient)

/**
 * 异常登记
 *
 * */
export const abnormalDefective = [
  {
    value: '301',
    title: '色差（缸差、颜色差异等）'
  },
  {
    value: '302',
    title: '污渍/斑点/水印'
  },
  {
    value: '303',
    title: '破损'
  },
  {
    value: '304',
    title: '线头'
  },
  {
    value: '305',
    title: '缝制不良（接缝、明线等）'
  },
  {
    value: '306',
    title: '面料不良(抽丝、面料不良异色线、粗纱等)'
  },
  {
    value: '307',
    title: '针眼'
  },
  {
    value: '308',
    title: '霉菌'
  },
  {
    value: '309',
    title: '生锈'
  },
  {
    value: '310',
    title: '商品有中文'
  },
  {
    value: '311',
    title: '纽扣不良（刮花、破损、掉漆等）'
  },
  {
    value: '312',
    title: '拉链不良（拉不上、刮花、破损等）'
  },
  {
    value: '313',
    title: '配件不良（腰带、丝巾、装饰物等配件不良）'
  },
  {
    value: '314',
    title: '有气味'
  },
  {
    value: '316',
    title: '通电不良'
  },
  {
    value: '317',
    title: '尺寸差异（尺寸明细和页面不一致）',
    isReject: true
  },
  {
    value: '318',
    title: '配件差异(口袋，腰带，纽扣，拉链，拉绳等)',
    isReject: true
  },
  {
    value: '319',
    title: '设计差异(压线，领口，腰头，袖口，领口，花纹，衣服设计等)',
    isReject: true
  },
  {
    value: '320',
    title: '染色不良',
    isReject: true
  },
  {
    value: '321',
    title: '抽绳不良',
    isReject: true
  },
  {
    value: '315',
    title: '其他不良'
  }
]
// 异常上报客户
export const customerAbnormalDefective = [
  {
    value: '301',
    title: '色差（缸差、颜色差异等）'
  },
  {
    value: '302',
    title: '污渍/斑点/水印'
  },
  {
    value: '303',
    title: '破损'
  },
  {
    value: '304',
    title: '线头'
  },
  {
    value: '305',
    title: '缝制不良（接缝、明线等）'
  },
  {
    value: '306',
    title: '面料不良(抽丝、面料不良异色线、粗纱等)'
  },
  {
    value: '307', 
    title: '针眼'
  },
  {
    value: '308',
    title: '霉菌'
  },
  {
    value: '309',
    title: '生锈'
  },
  {
    value: '310',
    title: '商品有中文'
  },
  {
    value: '311', 
    title: '纽扣不良（刮花、破损、掉漆等）'
  },
  {
    value: '312',
    title: '拉链不良（拉不上、刮花、破损等）'
  },
  {
    value: '313',
    title: '配件不良（腰带、丝巾、装饰物等配件不良）'
  },
  {
    value: '314',
    title: '有气味'
  },
  {
    value: '316',
    title: '通电不良'
  },
  {
    value: '315', 
    title: '其他不良'
  },
]

export const abnormalDefectiveMap = arrToMap(abnormalDefective)

export const ingredientTypeList = {
  1: '质检辅料',
  2: '成品辅料'
}
